import { Button } from '../atoms/Button';
import { Icon } from '../atoms/Icon';
import styles from './FilterChips.module.css';

export interface FilterChip {
  key: string;
  /** e.g. "Standort: Obstwiese". */
  label: string;
  onRemove: () => void;
}

export interface FilterChipsProps {
  chips: FilterChip[];
  /** Label of each chip's remove button, e.g. `(label) => \`${label} entfernen\``. */
  removeLabel: (chipLabel: string) => string;
  /** "Alle zurücksetzen"; shown from two chips on. */
  resetLabel: string;
  onReset: () => void;
}

/** Active filters as removable chips (docs/ux-richtlinien.md §6.3). */
export function FilterChips({ chips, removeLabel, resetLabel, onReset }: FilterChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className={styles.chips}>
      {chips.map((c) => (
        <span key={c.key} className={styles.chip}>
          {c.label}
          <button
            type="button"
            className={styles.remove}
            aria-label={removeLabel(c.label)}
            onClick={c.onRemove}
          >
            <Icon name="close" size="xs" />
          </button>
        </span>
      ))}
      {chips.length > 1 && (
        <Button variant="plain" size="xs" onClick={onReset}>
          {resetLabel}
        </Button>
      )}
    </div>
  );
}
